export const stepProperty = 'property'
export const stepIncomes = 'income'
export const stepDebts = 'debt'
export const stepSavings = 'saving'
export const stepActivities = 'activity'
export const stepLifestyle = 'expense'
